"use client";
import { useState, useEffect } from "react";
import Link from "next/link";
import { Container, Typography } from "@mui/material";

import { useStore, observer } from "../src/service/mobx";

function ErrorBoundary({ error, reset }) {
  const [showError, setShouldShowError] = useState(false);
  const { analytics, user, utilities } = useStore();

  useEffect(() => {
    if (user.loaded) {
      // report the error the user experienced
      console.error(error);

      const triedResetting = utilities.cookie.get("reset");

      if (triedResetting === null) {
        // First time - try automatic recovery - 10 minute cookie
        const cookiesEnabled = utilities.cookie.set("reset", 1, 0.007);

        if (cookiesEnabled) {
          // Try to recover automatically and Don't show error UI yet
          return reset();
        }
      }

      const triedReloading = utilities.cookie.get("reload");

      if (triedReloading === null) {
        // First time - try automatic recovery - 10 minute cookie
        const cookiesEnabled = utilities.cookie.set("reload", 1, 0.007);

        if (cookiesEnabled) {
          return window.location.reload();
        }
      }

      // Either we already tried OR cookies are disabled
      setShouldShowError(true);
      analytics.track.event("User Error", { error: error?.message ?? error });
    }
  }, [analytics, utilities, error, reset, user.loaded]);

  return showError ? (
    <Container
      maxWidth="expanded"
      sx={{
        gap: 3,
        height: "100dvh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <Typography
        variant="displayLg"
        fontSize={80}
        color="var(--tertiary-color)"
      >
        🤔
      </Typography>
      <Typography
        align="center"
        component="p"
        variant="displayMd"
        sx={{ textWrap: "balance" }}
      >
        Something went wrong
      </Typography>
      <Link href="/">Back to homepage</Link>
    </Container>
  ) : null;
}

export default observer(ErrorBoundary);
